export const SourceChips = ({ sources = [], onOpen }) => (
  <div className="flex flex-wrap gap-1.5" data-testid="source-chips">
    {sources.length === 0 && (
      <span className="font-mono text-[9px] uppercase tracking-[0.2em]" style={{ color: "var(--text-faint)" }}>
        nothing in the record for this
      </span>
    )}
    {sources.map((s, i) => (
      <button
        key={s.id || i}
        data-testid={`source-chip-${i + 1}`}
        onClick={() => onOpen?.(s)}
        className="group inline-flex items-center gap-2 rounded-full border px-2.5 py-1.5 text-[11px] transition-colors active:scale-[0.98]"
        style={{ borderColor: "var(--border-linen)", background: "rgba(244,239,230,0.025)", color: "var(--text-dim)" }}
      >
        <span className="h-1.5 w-1.5 shrink-0 rounded-full" style={{ backgroundColor: "var(--lab-accent)" }} />
        <span className="max-w-[160px] truncate">{s.title}</span>
        <span className="font-mono text-[8.5px] uppercase tracking-[0.16em]" style={{ color: "var(--text-faint)" }}>{s.type}</span>
      </button>
    ))}
  </div>
);
